import React, { Context } from 'react';

export class LoaderContextHolder {
  isLoaderActive: () => boolean = () => true;
  requestLoaderShow = (tag?: string) => {};
  requestLoaderHide = (tag?: string) => {};
}

export const LoaderContext: Context<LoaderContextHolder> = React.createContext(
  new LoaderContextHolder(),
);
